<template>
  <f7-page ref="page" name="customers" infinite :infinite-distance="100" :infinite-preloader="isLoading" @infinite="onLoadMore">

    <f7-progressbar v-if="isLoading" color="green" infinite class="position-absolute" key="1"></f7-progressbar>
    <!-- Top Navbar -->
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Back">
      </f7-nav-left>
      <f7-nav-title sliding>{{ $t('Customers') }} {{ !mainCustomerName ? '' : '- ' + mainCustomerName }}</f7-nav-title>
      <f7-nav-right v-if="!mainCustomerCode">
        <f7-link href="/customers/edit/" icon="f7-icons icon-header-added size-22" ></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <f7-toolbar position="top" >
      <form class="searchbar custom-searchbar" @submit.prevent="onSearchSubmit">
        <div class="searchbar-inner">
          <div class="searchbar-input-wrap">
            <input type="search" v-model.trim="search" :placeholder="$t('Search')">
            <span class="input-clear-button"></span>
            <button type="submit" class="submit-button ripple">
              <i class="icon f7-icons icon-search  "></i>
            </button>
          </div>
        </div>
      </form>
    </f7-toolbar>

    <f7-block v-if="!isFirstSearchDone">
      <p v-html="$t('SearchCustomersDescription')"></p>
    </f7-block>
    <f7-block v-else-if="!isLoading && isNoData && queryPage === 1">
      <p>{{ $t('NoCustomersFound') }}</p>
    </f7-block>

    <f7-list
        ref="vl"
        class="vl vl-customers no-margin-top bigger-item-text"
        virtual-list
        media-list
        no-hairlines
        :virtual-list-params="{ items, renderExternal, height: heightCalc }"
    >
      <ul>
        <f7-list-item
            v-for="(item, index) in vlData.items"
            link="#"
            :key="item.Code"
            :title="item.Name"
            :header="item.Agent"
            :style="`top: ${vlData.topPosition}px`"
            @click="openItemMenu(item, index)"
        >

          <template #media>
            <div class="customer-icon">
              {{ getCustomerIconLetters(item.Name) }}
            </div>
            <span class="status" :class="getCustomerStatusClass(item.State)"></span>
          </template>
          <template #text>
            <div >{{ $t('Type') }}: <b>{{ item.CTypeValue ? getCustomerType(item.CTypeValue) : $t('na') }}</b></div>
            <div >{{ $t('Email') }}: <b>{{ item.Email ? item.Email : $t('na') }}</b></div>
            <div >{{ $t('LoginName') }}: <b>{{ item.LoginName ? item.LoginName : $t('na') }}</b></div>
            <div >{{ $t('ContactName') }}: <b>{{ item.Contact ? item.Contact : $t('na') }}</b></div>
            <div >
              <span class="margin-right">
                {{ $t('Assets') }}: <b>{{ item.Total }}</b>
              </span>
              <span class="margin-right-half">
                <i class="icon f7-icons size-16 text-color-lightblue icon-live-protect2"></i> {{ parseInt(item.Protect)+parseInt(item.QProtect)+parseInt(item.WiTiProtect) }}
              </span>
              <span class="margin-right-half">
                <i class="icon f7-icons size-16 text-color-lightblue icon-live-loc82"></i> {{ parseInt(item.Loc8) }}
              </span>
              <span class="margin-right-half">
                <i class="icon f7-icons size-16 text-color-lightblue icon-live-track2"></i> {{ parseInt(item.Track)+parseInt(item.WiTiTrack) }}
              </span>
              <span class="margin-right-half">
                <i class="icon f7-icons size-16 text-color-lightblue icon-live-watch2"></i> {{ parseInt(item.Watch)+parseInt(item.BoatWatch) }}
              </span>
              <span class="margin-right-half">
                <i class="icon f7-icons size-16 text-color-lightblue icon-live-no-plan"></i> {{ parseInt(item.DeActivate)+parseInt(item.Other) }}
              </span>
            </div>
          </template>
          <!--Agent: "Quiktrak Ukraine Limited"
              BoatWatch: "0"
              CType: "私人"
              CTypeValue: "5"
              Code: "dd8d6555-c5b6-4405-bd36-f691b69b8775"
              Contact: "Игорь Викторович Галак"
              Country: "Ukraine"
              CreateDate: "30/12/2016 21:30:30"
              DeActivate: "0"
              Email: "igoru2000@yandex.ru"
              Loc8: "0"
              LoginName: "eurodom"
              Mobile: "0679912217"
              Name: "EuroDom"
              Number: ""
              Other: "0"
              Protect: "0"
              QProtect: "0"
              Quiktrak: "0"
              SecurityCode: "000000"
              State: "Suspended"
              Telephone: ""
              TimeZone: "3"
              TimeZoneCode: "E. Europe Standard Time"
              Total: "5"
              Track: "5"
              Watch: "0"
              WebSiteCode: "00000000-0000-0000-0000-000000000000"
              WiTiProtect: "0"
              WiTiTrack: "0"
              -->
        </f7-list-item>
      </ul>
    </f7-list>

    <customer-menu
        v-model:isOpened = isCustomerMenuOpened
        :customerData = "selectedCustomerData"
    />
  </f7-page>
</template>

<script>
//import {ApiMethods} from "../services/qt-api";
import {f7, theme} from "framework7-vue";
import {QTAPI} from "../../services/qt-api";
import {mapGetters} from "vuex";
import {HideKeyboard, getCustomerTypesFull} from "../../js/helpers";
import $$ from "dom7";

import CustomerMenu from "./components/customer-menu"

export default {
  name: "customers",

  props: {
    f7router: Object,
    f7route: Object,
  },

  components: {
    CustomerMenu
  },

  data() {
    return {
      isLoading: false,
      isFirstSearchDone: false,
      isInfiniteAllowed: true,
      isNoData: false,
      isCustomerMenuOpened: false,

      CustomerTypeList: getCustomerTypesFull(),
      items: [],
      vlData: {
        items: [],
      },
      vl: null,
      queryPage: 1,
      search: '',
      selectedCustomerData: {},

      mainCustomerName: this.f7route.query.mainCustomerName,
      mainCustomerCode: this.f7route.query.mainCustomerCode,
    }
  },

  computed: {
    ...mapGetters(['MajorToken', 'MinorToken', 'CustomerUpdateKey', 'SearchCancelToken'])
  },

  watch: {
    CustomerUpdateKey(){
      this.onSearchSubmit()
    }
  },

  mounted() {
    this.vl = f7.virtualList.get(this.$refs.vl.$el);
    this.onSearchSubmit()
  },

  methods: {
    onSearchSubmit(){
      //hide keyboard at phones
      HideKeyboard();
      //fix to not loadMore when user has scrolled down list
      $$(this.$refs.page.$el).find('.page-content.infinite-scroll-content').scrollTo( 0, 0)

      this.queryPage = 1
      this.isInfiniteAllowed = true
      this.getData()
    },
    onLoadMore(){
      if(!this.isInfiniteAllowed) return
      this.isInfiniteAllowed = false
      ++this.queryPage
      this.getData()
    },
    async getData(){
      let data = {
        MajorToken: this.MajorToken,
        MinorToken: this.MinorToken,

        page: this.queryPage,
        rows: 20,
        sort: 'Name',
        order: 'asc',

        q: this.search
      }
      if(this.mainCustomerCode){
        data.PCode = this.mainCustomerCode
      }
      if(this.SearchCancelToken){
        this.SearchCancelToken.cancel("Operation canceled due to new request.")
      }
      this.isLoading = true
      let response = await QTAPI.GetCustomers(data)
      if(response?.isCanceled) return
      this.isLoading = false

      if(!response) return

      this.isFirstSearchDone = true
      this.isNoData = !response.rows.length;
      if(this.queryPage === 1){
        if(this.isNoData){
          this.vl.deleteAllItems()
          return
        }
        this.vl.replaceAllItems(response.rows);

      }else{
        if(this.isNoData){
          return
        }
        this.vl.appendItems(response.rows);
        this.isInfiniteAllowed = true
      }
    },
    renderExternal(vl, vlData) {
      this.vlData = vlData;
    },
    heightCalc(){
      return theme.ios ? 162 : 166;
    },
    getCustomerType(type){
      let typeObg = this.CustomerTypeList.find( itm => itm.code === parseInt(type))
      return !typeObg ? type : typeObg.name
    },
    getCustomerStatusClass(state){
      let states = {
        //'9_NO_DATA': 'status-gray',
        'Suspended': 'status-red',
        //'Suspended': 'status-orange',
        'Active': 'status-green',
      }
      return states[state] ? states[state] : 'status-gray'
    },
    getCustomerIconLetters(name){
      name = name.trim();
      let ret = name[0]
      let splitted = name.split(' ')
      if(splitted.length > 1){
        ret += ' ' + splitted[1][0]
      }else if(name[1]){
        ret += name[1]
      }
      return ret.toUpperCase()
    },
    openItemMenu(item){
      console.log(item)
      this.selectedCustomerData = item
      this.isCustomerMenuOpened = true
    },
  }
}
</script>

<style scoped>

</style>